import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { getCriteriaApiCrud, type GetCriteriaRequest } from "@/generated/fastapi";

export async function getCriteria(
  accessToken: string | null | undefined,
  request: GetCriteriaRequest,
) {
  const response = await getCriteriaApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status === 200) {
    return response.data;
  }

  throw new Error("Failed to load criteria");
}
